



























































import { Component, Vue } from 'vue-property-decorator';
import RestStatus from '@/client/components/core/RestStatus.vue';
import Alert from '@/client/components/core/Alert.vue';
import api from '../util/api';
// eslint-disable-next-line
// @ts-ignore
import { InfoAreas, Tabs, Parallax } from './_theme';

@Component({
  components: {
    Alert,
    InfoAreas,
    Tabs,
    Parallax,
    RestStatus,
  },
})
export default class GetStarted extends Vue {
  boolean = false;
  image = 'hex-bg.jpeg';
  year: number = new Date().getFullYear();
  isPPL = false;
  name = '';
  email = '';
  business = '';
  expertise = '';
  location = '';
  message = '';
  alertMessage = '';
  responseType = '';
  showAlert = false;
  loading = false;
  error = false;

  contentLeft: Array<any> = [
    {
      colorIcon: 'danger',
      icon: 'request_quote',
      title: 'Free Quote',
      description:
        "Set up your service when you need it. We'll work with your budget to provide you the level of service that best fits your needs.",
    },
    {
      colorIcon: 'primary',
      icon: 'group',
      title: 'Responsive',
      description:
        "Don't like to wait? Neither do we. We'll get back to you within 24 hours.",
    },
  ];

  resetForm() {
    this.name = '';
    this.email = '';
    this.boolean = false;
    this.business = '';
    this.expertise = '';
    this.location = '';
  }

  resetAlert() {
    this.alertMessage = '';
    this.responseType = '';
    this.showAlert = false;
  }

  popAlert(response: any) {
    this.responseType = response.status === 200 ? 'success' : 'danger';
    this.alertMessage = response.data;
    this.showAlert = true;
  }

  submitLead() {
    this.resetAlert();

    const lead = {
      name: this.name,
      email: this.email,
      business: this.business,
      expertise: this.expertise,
      location: this.location,
      isPPL: this.isPPL,
    };

    api('POST', 'https://rarequaticfinds.herokuapp.com/api/leads/main', lead)
      .then((response: any) => {
        this.loading = false;
        this.resetForm();
        this.popAlert(response);
      })
      .catch((err) => {
        const response = {
          status: 500,
          data: 'Unable to submit, maybe this is a duplicate?',
        };

        this.popAlert(response);
        this.error = true;
        throw err;
      });
  }
}
